import { render, staticRenderFns } from "./orderReivice.vue?vue&type=template&id=e13960ca"
import script from "./orderReivice.vue?vue&type=script&lang=js"
export * from "./orderReivice.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./orderReivice.vue?vue&type=style&index=0&id=e13960ca&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "37422962"
  
)

export default component.exports